// UI-only category: the API models tax as separate rate, type and pass-through fields.
export enum TaxCategory {
    SALES_TAX = 'SALES_TAX',
    INSURANCE_TAX = 'INSURANCE_TAX',
    SALES_TAX_PASS_THROUGH = 'SALES_TAX_PASS_THROUGH',
    UNKNOWN = 'UNKNOWN'
}

export const TaxCategoryLabels: Record<TaxCategory, string> = {
    [TaxCategory.INSURANCE_TAX]: $localize`Insurance tax`,
    [TaxCategory.SALES_TAX]: $localize`Sales tax`,
    [TaxCategory.SALES_TAX_PASS_THROUGH]: $localize`Sales tax: Pass-through item § 10(1) s. 5 UStG`,
    [TaxCategory.UNKNOWN]: '-'
};

export const taxCategoriesWithLabels = [
    TaxCategory.INSURANCE_TAX,
    TaxCategory.SALES_TAX,
    TaxCategory.SALES_TAX_PASS_THROUGH,
    TaxCategory.UNKNOWN
].map((taxCategory) => ({ value: taxCategory, label: TaxCategoryLabels[taxCategory] }));
